var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_88)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 13.4292C16.05 13.6636 15.9906 13.9354 15.8094 14.1136C15.6906 14.2292 15.5344 14.2886 15.375 14.2886C15.2906 14.2886 15.2031 14.2698 15.1219 14.2354L11.7688 12.7573C11.3469 12.9167 10.9156 13.0386 10.4719 13.1198C10.0188 13.8667 9.36875 14.5011 8.58125 14.9604C7.7 15.4761 6.68437 15.7511 5.64062 15.7573C5.625 15.7573 5.60938 15.7604 5.59375 15.7604C4.87187 15.7604 4.17188 15.6354 3.50938 15.3886L0.878125 16.5479C0.796875 16.5823 0.7125 16.6011 0.625 16.6011C0.465625 16.6011 0.309375 16.5417 0.190625 16.4261C0.00937499 16.2479 -0.05 15.9792 0.046875 15.7417L0.959375 13.4823C0.33125 12.6292 0 11.6354 0 10.5854C0 8.91045 0.86875 7.35107 2.3375 6.3792C2.47188 4.88545 3.17188 3.49795 4.3375 2.43232C5.62813 1.25107 7.3375 0.601074 9.15625 0.601074C10.975 0.601074 12.6844 1.25107 13.975 2.43232C15.2812 3.62607 16 5.21982 16 6.9167C16 7.19795 15.975 7.5167 15.9312 7.8167C15.8812 8.15732 15.5625 8.39482 15.2219 8.3417C14.8813 8.2917 14.6437 7.97295 14.6969 7.63232C14.7312 7.39482 14.7531 7.13545 14.7531 6.9167C14.75 4.12295 12.2406 1.85107 9.15625 1.85107C6.07188 1.85107 3.5625 4.12295 3.5625 6.9167C3.5625 9.36357 5.80937 11.9823 9.15625 11.9823C9.9875 11.9823 10.7875 11.8198 11.5344 11.5011C11.6938 11.4323 11.875 11.4354 12.0312 11.5042L14.2188 12.4667L13.4812 10.6448C13.3531 10.3261 13.5062 9.96045 13.825 9.83232C14.1438 9.7042 14.5094 9.85732 14.6375 10.1761L15.9531 13.4292ZM8.8 13.2261C7.06875 13.1448 5.46563 12.4698 4.25313 11.3011C3.27813 10.3636 2.63438 9.16982 2.40313 7.92295C1.66875 8.6417 1.24688 9.58545 1.24688 10.5854C1.24688 11.4573 1.55937 12.2854 2.14687 12.9761C2.29688 13.1542 2.3375 13.4011 2.25 13.6167L1.78125 14.7823L3.24375 14.1386C3.40313 14.0698 3.58125 14.0667 3.74062 14.1354C4.31562 14.3792 4.92813 14.5042 5.56563 14.5104C5.575 14.5104 5.58125 14.5104 5.59062 14.5104C6.825 14.5073 7.9875 14.0261 8.8 13.2261Z",
    fill: "url(#paint0_linear_0_88)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_88",
    x: -40,
    y: -24.3989,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_88",
    x1: 1.77777,
    y1: 16.8366,
    x2: 15.0216,
    y2: 2.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.601074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.c9044b90a299f752265a5c8b45e30ede.svg";
export { ForwardRef as ReactComponent };